import { useMedia } from '@wartek-id/react-utils'

import { WilayahSelectionProps } from './types'
import { WilayahSelectionDialog } from './WilayahSelectionDialog'
import { WilayahSelectionSheet } from './WilayahSelectionSheet'

export function WilayahSelectionResponsive({
  data,
  show,
  onClose,
  onSelect,
}: WilayahSelectionProps) {
  const isMd = useMedia('(min-width: 768px)', false)

  return (
    <>
      {isMd && (
        <WilayahSelectionDialog
          show={show}
          onClose={onClose}
          data={data}
          onSelect={onSelect}
        />
      )}
      {!isMd && (
        <WilayahSelectionSheet
          show={show}
          onClose={onClose}
          data={data}
          onSelect={onSelect}
        />
      )}
    </>
  )
}
